(function(){function init(){
/* ================= OCOA PDP — interactivity ================= */
(function(){
  'use strict';

  /* ---------- auto-stagger: promote children of [data-stagger] to .reveal ---------- */
  document.querySelectorAll('[data-stagger]').forEach(function(parent){
    Array.prototype.forEach.call(parent.children, function(child, i){
      child.classList.add('reveal');
      if(!child.style.getPropertyValue('--i')) child.style.setProperty('--i', i);
    });
  });
  /* tag standalone headings/CTAs for reveal */
  document.querySelectorAll('h2, .btn, .rating-row, .buybox__title, .promise, .step, .conf').forEach(function(el){
    if(!el.closest('[data-stagger]') && !el.classList.contains('reveal')) el.classList.add('reveal');
  });

  /* ---------- reveal on scroll (force-on for headless / reduced-motion) ---------- */
  var REVEAL_ALL = navigator.webdriver || matchMedia('(prefers-reduced-motion: reduce)').matches;
  var revealEls = document.querySelectorAll('.reveal');
  if(REVEAL_ALL){
    revealEls.forEach(function(e){ e.classList.add('in'); });
  } else {
    var io = new IntersectionObserver(function(entries){
      entries.forEach(function(en){ if(en.isIntersecting){ en.target.classList.add('in'); io.unobserve(en.target); } });
    }, {threshold:0.12, rootMargin:'0px 0px -8% 0px'});
    revealEls.forEach(function(e){ io.observe(e); });
  }

  /* ---------- gallery: thumb click + arrows ---------- */
  var gMain = document.getElementById('galleryMain');
  var thumbWrap = document.querySelector('[data-thumbs]');
  if(gMain && thumbWrap){
    var thumbs = Array.prototype.slice.call(thumbWrap.querySelectorAll('.gallery__thumb'));
    var gi = 0;
    var GAL_NO_ANIM = navigator.webdriver || matchMedia('(prefers-reduced-motion: reduce)').matches;
    // keep the active thumbnail scrolled into view within the thumbs strip (scrolls the strip only, not the page)
    function centerThumb(){
      var t = thumbs[gi]; if(!t || !thumbWrap) return;
      var cr = thumbWrap.getBoundingClientRect(), tr = t.getBoundingClientRect();
      // direct scrollLeft/scrollTop assignment (scrollBy is cancelled by scroll-snap on this container)
      if(thumbWrap.scrollWidth > thumbWrap.clientWidth + 2){
        thumbWrap.scrollLeft = Math.max(0, thumbWrap.scrollLeft + (tr.left - cr.left) - (thumbWrap.clientWidth - tr.width) / 2);
      } else if(thumbWrap.scrollHeight > thumbWrap.clientHeight + 2){
        thumbWrap.scrollTop = Math.max(0, thumbWrap.scrollTop + (tr.top - cr.top) - (thumbWrap.clientHeight - tr.height) / 2);
      }
    }
    function setGallery(i){
      gi = (i + thumbs.length) % thumbs.length;
      var img = thumbs[gi].querySelector('img');
      var src = img.getAttribute('src');
      thumbs.forEach(function(t){ t.classList.remove('is-active'); });
      thumbs[gi].classList.add('is-active');
      centerThumb();
      if(gMain.getAttribute('src') === src) return;
      if(GAL_NO_ANIM){ gMain.src = src; return; }
      // crossfade: fade out, swap once the new image is decoded, fade back in
      var loaded = false, faded = false;
      function swap(){
        if(!(loaded && faded)) return;
        gMain.src = src;
        requestAnimationFrame(function(){ gMain.classList.remove('is-swapping'); });
      }
      gMain.classList.add('is-swapping');
      var pre = new Image();
      pre.onload = pre.onerror = function(){ loaded = true; swap(); };
      pre.src = src;
      if(pre.complete) loaded = true;
      setTimeout(function(){ faded = true; swap(); }, 200);
    }
    thumbs.forEach(function(t, i){ t.addEventListener('click', function(){ setGallery(i); }); });
    var prev = document.querySelector('.gallery__arrow--prev');
    var next = document.querySelector('.gallery__arrow--next');
    if(prev) prev.addEventListener('click', function(){ setGallery(gi-1); });
    if(next) next.addEventListener('click', function(){ setGallery(gi+1); });
  }

  /* ---------- price model: size + subscribe/one-time ---------- */
  var sizeWrap = document.querySelector('[data-sizes]');
  var purchWrap = document.querySelector('[data-purchase]');
  function fmt(n){ return '$' + n.toFixed(2); }
  function activeSize(){ return sizeWrap ? sizeWrap.querySelector('.size.is-active') : null; }
  function refreshPrices(){
    var s = activeSize(); if(!s) return;
    var one = parseFloat(s.dataset.price);
    var sub = parseFloat(s.dataset.sub);
    var nowSub = document.querySelector('[data-now-sub]');
    var wasSub = document.querySelector('[data-was-sub]');
    var nowOne = document.querySelector('[data-now-one]');
    var wasOne = document.querySelector('[data-was-one]');
    if(nowSub) nowSub.textContent = fmt(sub);
    if(wasSub) wasSub.textContent = fmt(one);
    if(nowOne) nowOne.textContent = fmt(one);
    if(wasOne) wasOne.textContent = fmt(one * 1.049);
  }
  if(sizeWrap){
    sizeWrap.querySelectorAll('.size').forEach(function(btn){
      btn.addEventListener('click', function(){
        sizeWrap.querySelectorAll('.size').forEach(function(b){ b.classList.remove('is-active'); });
        btn.classList.add('is-active');
        refreshPrices();
      });
    });
  }
  if(purchWrap){
    var labels = purchWrap.querySelectorAll('.purch');
    labels.forEach(function(lab){
      lab.addEventListener('click', function(){
        labels.forEach(function(l){ l.classList.remove('is-active'); });
        lab.classList.add('is-active');
        var r = lab.querySelector('input'); if(r) r.checked = true;
      });
    });
  }
  refreshPrices();

  /* ---------- quantity stepper ---------- */
  document.querySelectorAll('[data-qty]').forEach(function(q){
    var n = q.querySelector('[data-qty-n]');
    var v = 1;
    q.querySelector('[data-dec]').addEventListener('click', function(){ v = Math.max(1, v-1); n.textContent = v; });
    q.querySelector('[data-inc]').addEventListener('click', function(){ v = v+1; n.textContent = v; });
  });

  /* ---------- accordion: single-open per group ---------- */
  document.querySelectorAll('[data-accordion]').forEach(function(group){
    var items = group.querySelectorAll('details');
    items.forEach(function(d){
      d.addEventListener('toggle', function(){
        if(d.open){ items.forEach(function(o){ if(o !== d) o.open = false; }); }
      });
    });
  });

  /* ---------- FAQ tabs (visual only) ---------- */
  document.querySelectorAll('[data-faq-tabs]').forEach(function(tabs){
    var scope = tabs.closest('.faq') || document;
    var list = scope.querySelector('[data-faq-list]') || document.querySelector('[data-faq-list]');
    function apply(cat){
      if(!list) return;
      list.querySelectorAll('details[data-cat]').forEach(function(d){
        d.style.display = (d.getAttribute('data-cat') === cat) ? '' : 'none';
      });
    }
    tabs.querySelectorAll('.faq__tab').forEach(function(tab){
      tab.addEventListener('click', function(){
        tabs.querySelectorAll('.faq__tab').forEach(function(t){ t.classList.remove('is-active'); });
        tab.classList.add('is-active');
        apply(tab.getAttribute('data-cat') || 'product');
      });
    });
    var act = tabs.querySelector('.faq__tab.is-active') || tabs.querySelector('.faq__tab');
    if(act && list && list.querySelector('details[data-cat]')) apply(act.getAttribute('data-cat') || 'product');
  });

  /* ---------- carousels: drag-to-scroll on rails ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function(rail){
    var down=false, dragging=false, startX, startScroll, pid;
    rail.addEventListener('pointerdown', function(e){
      // never hijack clicks on interactive elements (Quick Add, links, cart icons)
      if(e.target.closest('button, a, [data-add-variant], input, select')) return;
      down=true; dragging=false; startX=e.pageX; startScroll=rail.scrollLeft; pid=e.pointerId;
    });
    rail.addEventListener('pointermove', function(e){
      if(!down) return;
      var dx = e.pageX - startX;
      if(!dragging && Math.abs(dx) > 5){ dragging=true; try{ rail.setPointerCapture(pid); }catch(_){} }
      if(dragging){ rail.scrollLeft = startScroll - dx; }
    });
    rail.addEventListener('pointerup', function(){ down=false; dragging=false; });
    rail.addEventListener('pointercancel', function(){ down=false; dragging=false; });
  });

  /* ---------- result video mute toggles ---------- */
  document.querySelectorAll('[data-vid-mute]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var card = btn.closest('.vidcard');
      var v = card && card.querySelector('video');
      if(!v) return;
      v.muted = !v.muted;
      btn.classList.toggle('is-on', !v.muted);
    });
  });


  /* ---------- auto-scroll carousels (pause on hover) ---------- */
  document.querySelectorAll('[data-carousel]').forEach(function(rail){
    if(rail.hasAttribute('data-no-autoscroll')) return;
    if(rail.getAttribute('data-autoscroll-init')) return;
    rail.setAttribute('data-autoscroll-init','1');
    var paused=false, dir=1;
    rail.addEventListener('mouseenter',function(){paused=true;});
    rail.addEventListener('mouseleave',function(){paused=false;});
    setInterval(function(){
      if(paused) return;
      if(rail.scrollWidth - rail.clientWidth - rail.scrollLeft < 2) dir=-1;
      else if(rail.scrollLeft < 2) dir=1;
      rail.scrollLeft += dir * 0.7;
    }, 20);
  });

  /* ---------- add to cart (Pairs ADD + Real Results) via theme modal cart ---------- */
  document.addEventListener('click', function(e){
    var t = e.target.closest('[data-add-variant]');
    if(!t || !t.closest('.ocoa-pdp')) return;
    e.preventDefault();
    var id = t.getAttribute('data-add-variant');
    if(!id || t.dataset.adding) return;
    t.dataset.adding = '1'; t.classList.add('is-adding');
    var fd = new FormData();
    fd.append('id', id); fd.append('quantity', '1');
    fd.append('sections', 'cart-items,cart-footer,cart-item-count');
    fd.append('sections_url', location.pathname);
    fetch('/cart/add', { method:'POST', headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'}, body: fd })
      .then(function(r){ if(!r.ok) throw r; return r.json(); })
      .then(function(data){
        document.body.dispatchEvent(new CustomEvent('shapes:modalcart:afteradditem', { bubbles:true, detail:{ response:data } }));
        t.classList.remove('is-adding'); t.classList.add('is-added');
        setTimeout(function(){ t.classList.remove('is-added'); delete t.dataset.adding; }, 1600);
      })
      .catch(function(){ t.classList.remove('is-adding'); delete t.dataset.adding; alert('Sorry, that item could not be added to the cart.'); });
  });

  /* ---------- buy box: Recharge selling-plan + AJAX ATC + sticky bar ---------- */
  (function(){
    var form = document.getElementById('ocoa-pdp-form');
    if(!form) return;
    var planInput = form.querySelector('[data-selling-plan]');
    var freq = document.querySelector('[data-sub-freq]');
    var subRadio = document.querySelector('[data-purch-sub] input');
    var oneRadio = document.querySelector('[data-purch-one] input');
    var nowSub = document.querySelector('[data-now-sub]');
    var nowOne = document.querySelector('[data-now-one]');
    var stickyPrice = document.querySelector('[data-sticky-price]');
    function isSub(){ return !!(subRadio && subRadio.checked); }
    function syncPlan(){
      if(planInput){
        if(isSub()){ if(freq) planInput.value = freq.value; planInput.disabled = false; }
        else { planInput.value = ''; planInput.disabled = true; }
      }
      // reflect the selected plan's real price (allocations differ per plan)
      if(isSub() && freq && nowSub){ var opt = freq.options[freq.selectedIndex]; if(opt && opt.dataset.price) nowSub.textContent = opt.dataset.price; }
      if(stickyPrice){ var p = isSub() ? (nowSub && nowSub.textContent) : (nowOne && nowOne.textContent); if(p) stickyPrice.textContent = p.trim(); }
    }
    if(subRadio) subRadio.addEventListener('change', syncPlan);
    if(oneRadio) oneRadio.addEventListener('change', syncPlan);
    if(freq){ freq.addEventListener('change', syncPlan); freq.addEventListener('click', function(e){ e.stopPropagation(); }); }
    document.querySelectorAll('[data-purchase] .purch').forEach(function(lab){ lab.addEventListener('click', function(){ setTimeout(syncPlan, 0); }); });
    syncPlan();

    function addToCart(){
      var fd = new FormData(form);
      if(planInput && planInput.disabled) fd.delete('selling_plan');
      fd.append('sections', 'cart-items,cart-footer,cart-item-count');
      fd.append('sections_url', location.pathname);
      return fetch('/cart/add', { method:'POST', headers:{'Accept':'application/javascript','X-Requested-With':'XMLHttpRequest'}, body: fd })
        .then(function(r){ return r.json().then(function(data){ return { ok:r.ok, data:data }; }, function(){ return { ok:r.ok, data:{} }; }); })
        .then(function(res){
          if(res.ok){
            document.body.dispatchEvent(new CustomEvent('shapes:modalcart:afteradditem', { bubbles:true, detail:{ response:res.data } }));
            return;
          }
          // A non-OK response here is usually RECOVERABLE, not a real failure. For stock-limited
          // bundles Shopify caps the quantity and returns 422 "Only N items were added ... due to
          // availability" WHILE the items ARE added to the cart. The old blanket "Sorry, that could
          // not be added" was misleading (it fired even though items landed). Surface Shopify's real
          // reason instead; the drawer renders the added items correctly the next time it opens.
          var msg = (res.data && (res.data.description || res.data.message)) || 'Sorry, that could not be added to the cart.';
          alert(msg);
        })
        .catch(function(){ alert('Sorry, that could not be added to the cart.'); });
    }
    form.addEventListener('submit', function(e){ e.preventDefault(); addToCart(); });

    var sticky = document.querySelector('[data-sticky-atc]');
    var atcBtn = form.querySelector('.atc__btn');
    if(sticky && atcBtn && 'IntersectionObserver' in window){
      new IntersectionObserver(function(entries){
        entries.forEach(function(en){ sticky.hidden = en.isIntersecting; });
      }, { threshold: 0 }).observe(atcBtn);
      var sAdd = sticky.querySelector('[data-sticky-add]');
      if(sAdd) sAdd.addEventListener('click', addToCart);
    }
  })();

  /* ---------- results rail: arrow nav + disable at first/last slide ---------- */
  document.querySelectorAll('.results__railwrap').forEach(function(wrap){
    var rail = wrap.querySelector('.results__rail');
    var prev = wrap.querySelector('[data-results-prev]');
    var next = wrap.querySelector('[data-results-next]');
    if(!rail || !prev || !next) return;
    function step(){
      var card = rail.querySelector('.vidcard');
      return card ? Math.round(card.getBoundingClientRect().width + 13) : Math.round(rail.clientWidth * 0.8);
    }
    function update(){
      var max = rail.scrollWidth - rail.clientWidth;
      prev.disabled = rail.scrollLeft <= 1;
      next.disabled = rail.scrollLeft >= max - 1;
    }
    prev.addEventListener('click', function(){ rail.scrollBy({ left: -step(), behavior: 'smooth' }); });
    next.addEventListener('click', function(){ rail.scrollBy({ left: step(), behavior: 'smooth' }); });
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update);
    update();
  });

  /* ---------- carousel nav arrows (ritual etc) ---------- */
  document.querySelectorAll('[data-rail-prev],[data-rail-next]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var wrap = btn.closest('.ritual__railwrap') || btn.parentElement;
      var rail = wrap.querySelector('[data-rail]') || wrap.querySelector('[data-carousel]');
      if(!rail) return;
      var card = rail.querySelector('.pcard, .vidcard, article');
      var step = card ? card.getBoundingClientRect().width + 24 : 400;
      rail.scrollBy({ left: btn.hasAttribute('data-rail-next') ? step : -step, behavior: 'smooth' });
    });
  });

  /* ---------- UGC video lightbox (click-to-play) ---------- */
  (function(){
    var lb = document.querySelector('[data-ugc-lightbox]');
    var player = lb && lb.querySelector('[data-ugc-player]');
    if(!lb || !player) return;
    function openLb(src){ player.src = src; lb.hidden = false; player.muted = false; player.currentTime = 0; var p = player.play(); if(p && p.catch) p.catch(function(){}); document.body.style.overflow = 'hidden'; }
    function closeLb(){ player.pause(); player.removeAttribute('src'); player.load(); lb.hidden = true; document.body.style.overflow = ''; }
    document.querySelectorAll('[data-ugc-video]').forEach(function(cell){
      cell.addEventListener('click', function(){ var src = cell.getAttribute('data-ugc-video'); if(src) openLb(src); });
    });
    lb.addEventListener('click', function(e){ if(e.target === lb || (e.target.closest && e.target.closest('[data-ugc-close]'))) closeLb(); });
    document.addEventListener('keydown', function(e){ if(e.key === 'Escape' && !lb.hidden) closeLb(); });
  })();

  /* ---------- close mobile menu on link tap ---------- */
  var navToggle = document.getElementById('navToggle');
  if(navToggle){
    document.querySelectorAll('.nav__menu--left a').forEach(function(a){
      a.addEventListener('click', function(){ navToggle.checked = false; });
    });
  }
})();

}
if(document.readyState==="loading"){document.addEventListener("DOMContentLoaded",init);}else{init();}})();